export default "__VITE_ASSET__0rRJUM23__"